import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const StatCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '120px', // Fixed height for circular appearance
  width: '120px', // Fixed width for circular appearance
  borderRadius: '50%', // Completely round cards
  margin: '0 auto', // Center the card in its grid cell
  boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.15)', // More prominent shadow
  transition: 'transform 0.2s, box-shadow 0.2s',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)', // Even more prominent shadow on hover
  },
}));

const SummaryCards = ({ data }) => {

  // LDM brand colors
  const ldmColors = {
    primary: '#2D3A45',
    secondary: '#FF5722',
    accent1: '#3D4A55',
    accent2: '#FF7A50',
    success: '#4CAF50',
    warning: '#FFC107',
    error: '#F44336',
    info: '#2196F3',
    mediumGrey: '#808080' // Medium grey color for the left three cards
  };

  const allStats = [
    {
      title: 'Active Projects',
      value: data?.totalProjects || 0,
      color: ldmColors.mediumGrey
    },
    {
      title: 'Team Members',
      value: data?.teamMembers || 0,
      color: ldmColors.mediumGrey
    },
    {
      title: 'Planned Hours',
      value: data?.plannedHours?.toFixed(1) || 0,
      color: ldmColors.success
    },
    {
      title: 'Logged Hours',
      value: data?.actualHours?.toFixed(1) || 0,
      color: data?.actualHours > data?.plannedHours ? ldmColors.error : ldmColors.success
    },
    {
      title: 'User Efficiency',
      value: `${data?.utilization?.toFixed(1) || 0}%`,
      color: data?.utilization > 80 ? ldmColors.success : data?.utilization < 60 ? ldmColors.warning : ldmColors.info
    }
  ];

  // No filtering needed - all stats are visible to all users
  const stats = allStats;

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(3, 1fr)', lg: 'repeat(5, 1fr)' }, gap: 2, mb: 3 }}>
      {stats.map((stat, index) => (
        <Box key={index} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <StatCard sx={{ backgroundColor: stat.color, color: 'common.white' }}>
            <Typography variant="subtitle2" sx={{ opacity: 0.9, textAlign: 'center', fontSize: '0.75rem' }}>{stat.title}</Typography>
            <Typography variant="h5" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
              {stat.prefix || ''}{stat.value}
            </Typography>
          </StatCard>
        </Box>
      ))}
    </Box>
  );
};

export default SummaryCards;